const ConferenciaHome = () => import(/* "group-pabx-cadastros-conferencia" */ '../_views/ConferenciaHome')
const AtualizarConferencia = () => import(/* "group-pabx-cadastros-conferencia" */ '../_views/AtualizarConferencia')

import { permissionsPabx } from '../../../../../utils/permissionsPabx'

export default [
  {
    path: 'conferencia',
    component: ConferenciaHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Conferencia',
  },
  {
    path: 'conferencia/atualizar/:_id',
    component: AtualizarConferencia,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Conferencia/atualizar',
    props: true,
  },
]
